import { cva, VariantProps } from "class-variance-authority";
import React, { TextareaHTMLAttributes } from "react";
import { formControlVariants } from "../classes";

const styles = cva([
  "h-full w-full px-3 py-1 rounded border-gray-300",
  formControlVariants({ vSize: null }),
]);
type VProps = VariantProps<typeof styles>;

export interface TextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement>,
    VProps {
  className?: string;
  "data-testid"?: string;
}

/**
 *
 */
export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, "data-testid": dataTestId, ...rest }, ref) => {
    const testId = dataTestId || `textarea-${rest.name || "default"}`;

    return (
      <textarea
        className={styles({ className })}
        ref={ref}
        data-testid={testId}
        {...rest}
      ></textarea>
    );
  },
);
